var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuGameColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bf8b29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    stopColor: "#fed569"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bf8b29"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_19964",
    "data-name": "Group 19964",
    transform: "translate(2608 9784)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19962",
    "data-name": "Group 19962",
    transform: "translate(-2953.327 -11153.696)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_100683",
    "data-name": "Path 100683",
    d: "M-2142.306,492.746l-1.167-.49a5.377,5.377,0,0,0,.082-.925,5.38,5.38,0,0,0-.07-.863l1.17-.477a.177.177,0,0,0,.1-.231l-.761-1.865a.177.177,0,0,0-.231-.1l-1.166.476a5.377,5.377,0,0,0-1.259-1.279l.486-1.156a.177.177,0,0,0-.095-.232l-1.856-.78a.177.177,0,0,0-.231.094l-.482,1.147a5.369,5.369,0,0,0-.949-.086,5.377,5.377,0,0,0-.858.069l-.468-1.146a.177.177,0,0,0-.23-.1l-1.865.761a.177.177,0,0,0-.1.231l.465,1.14a5.369,5.369,0,0,0-1.293,1.275l-1.132-.476a.177.177,0,0,0-.231.095l-.781,1.856a.177.177,0,0,0,.094.232l1.129.475a5.413,5.413,0,0,0-.083.933,5.369,5.369,0,0,0,.074.885l-1.135.463a.177.177,0,0,0-.1.231l.761,1.865a.177.177,0,0,0,.231.1l1.14-.465a5.378,5.378,0,0,0,1.278,1.284l-.48,1.141a.177.177,0,0,0,.095.232l1.856.78a.177.177,0,0,0,.232-.095l.483-1.149a5.365,5.365,0,0,0,.91.079,5.382,5.382,0,0,0,.891-.075l.473,1.159a.177.177,0,0,0,.231.1l1.865-.761a.177.177,0,0,0,.1-.231l-.476-1.167a5.376,5.376,0,0,0,1.27-1.262l1.166.49a.177.177,0,0,0,.231-.095l.78-1.856A.177.177,0,0,0-2142.306,492.746Z",
    transform: "translate(2504.516 888.862)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_142806",
    "data-name": "Path 142806",
    d: "M10.5,2A8.5,8.5,0,1,0,19,10.5,8.51,8.51,0,0,0,10.5,2m0-2A10.5,10.5,0,1,1,0,10.5,10.5,10.5,0,0,1,10.5,0Z",
    transform: "translate(-2608 -9784)",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuGameColor);
export default __webpack_public_path__ + "static/media/menu-game-color.6a3469e49c2dd498972729157d676914.svg";
export { ForwardRef as ReactComponent };